webpackJsonp([24],{

/***/ 1039:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_assets_js_report_expend_js__ = __webpack_require__(1155);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02ed59ec_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_report_expend_vue__ = __webpack_require__(1381);
var normalizeComponent = __webpack_require__(494)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_assets_js_report_expend_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02ed59ec_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_report_expend_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1052:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_axios__);




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_1_axios___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  PrintsendShiftHost: function PrintsendShiftHost(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/pos/send/slip', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  saleDetail: function saleDetail(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/report/daily', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  salePosDetail: function salePosDetail(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/report/pos/daily', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  saleCreditDetail: function saleCreditDetail(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/report/credit/daily', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  saleHoldDetail: function saleHoldDetail(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/report/holdbill/daily', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  saleSummary: function saleSummary(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/report/total/daily', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  expenseReport: function expenseReport(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'company/v1/report/expense', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  profitReport: function profitReport(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'stock/v1/report/profit/item/group', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  movementReport: function movementReport(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'stock/v1/report/tran/itemtoitem', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  stockReport: function stockReport(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'stock/v1/report/stock/remain', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  }
});

/***/ }),

/***/ 1155:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_service_report__ = __webpack_require__(1052);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_service_pos__ = __webpack_require__(498);





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      host_list: [],
      report_data: [],
      host: '',
      start_date: __WEBPACK_IMPORTED_MODULE_1_moment___default()(new Date()),
      end_date: __WEBPACK_IMPORTED_MODULE_1_moment___default()(new Date()),
      header: {
        headers: {
          'Access-Token': sessionStorage.token
        }
      },
      form_data: '',
      form_host: ''
    };
  },

  methods: {
    getHost: function getHost() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_3__services_service_pos__["a" /* default */].getHostShift(this.REST_URL, this.header, function (result) {
        if (result.response === 'success') {
          _this.host_list = result.data;
          _this.host = _this.host_list[0];
          _this.getExpend();
        } else {
          _this.$notification['warning']({
            message: 'ดึงข้อมูลจุดขายไม่ได้',
            description: result.message
          });
        }
      }, function (error) {
        alert('ไม่สามารถเข้าถึงข้อมูล ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
      });
    },
    getExpend: function getExpend() {
      var _this2 = this;

      var obj = {
        host_code: this.host.host_code,
        company_id: this.$store.state.user.company_id,
        branch_id: this.$store.state.user.branch_id,
        begin_date: this.dateFormatDMY2(this.start_date),
        end_date: this.dateFormatDMY2(this.end_date)
      };
      this.$store.commit('Loading');
      __WEBPACK_IMPORTED_MODULE_2__services_service_report__["a" /* default */].expenseReport(this.REST_URL, this.header, obj, function (result) {
        _this2.$store.commit('Loading');
        if (result.response === 'success') {
          _this2.report_data = result.data;
          _this2.form_data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(result.data);
          _this2.form_host = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this2.host);
        } else {
          _this2.$notification['warning']({
            message: 'ดึงข้อมูลรายงานไม่ได้',
            description: result.message
          });
        }
      }, function (error) {
        alert('ไม่สามารถเข้าถึงข้อมูล ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
        _this2.$store.commit('Loading');
      });
    },
    timeFormat: function timeFormat(str) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(str).format('HH:mm:ss');
    },
    count_expen: function count_expen(obj) {
      var sum = 0;
      obj.forEach(function (val) {
        sum += val['amount'];
      });
      return sum;
    }
  },
  mounted: function mounted() {
    this.getHost();
  }
});

/***/ }),

/***/ 1381:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card mt-3",style:({ 'min-height': _vm.$store.state.screenHeight - 100 + 'px' })},[_c('div',{staticClass:"card-body text-center"},[_c('h1',{staticStyle:{"font-weight":"bold"}},[_vm._v("รายงาน (เงินออก) ค่าใช้จ่ายประจำวัน")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-4 col-form-label text-right",attrs:{"for":"date"}},[_vm._v("เลือกจุดขาย")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.host),expression:"host"}],staticClass:"custom-select mr-sm-2",attrs:{"id":"Host"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.host=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.getExpend]}},_vm._l((_vm.host_list),function(h,i){return _c('option',{key:'host' + i,domProps:{"value":h}},[_vm._v(_vm._s(h.host_name))])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-3 col-form-label text-right",attrs:{"for":"date"}},[_vm._v("จากวันที่")]),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('a-date-picker',{staticClass:"form-control",attrs:{"format":'DD/MM/YYYY',"id":"date"},model:{value:(_vm.start_date),callback:function ($$v) {_vm.start_date=$$v},expression:"start_date"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-3 col-form-label text-right",attrs:{"for":"date"}},[_vm._v("ถึงวันที่")]),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('a-date-picker',{staticClass:"form-control",attrs:{"format":'DD/MM/YYYY',"id":"date"},model:{value:(_vm.end_date),callback:function ($$v) {_vm.end_date=$$v},expression:"end_date"}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-2"}),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('button',{staticClass:"btn btn-success btn-block",attrs:{"type":"button"},on:{"click":_vm.getExpend}},[_c('i',{staticClass:"fas fa-redo"}),_vm._v(" ประมลผล\n          ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('form',{attrs:{"action":"/static/pdf/report_expend.php","method":"POST","target":"_blank"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.start_date),expression:"start_date"}],attrs:{"type":"hidden","name":"date_start"},domProps:{"value":(_vm.start_date)},on:{"input":function($event){if($event.target.composing){ return; }_vm.start_date=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.end_date),expression:"end_date"}],attrs:{"type":"hidden","name":"date_end"},domProps:{"value":(_vm.end_date)},on:{"input":function($event){if($event.target.composing){ return; }_vm.end_date=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form_host),expression:"form_host"}],attrs:{"type":"hidden","name":"host"},domProps:{"value":(_vm.form_host)},on:{"input":function($event){if($event.target.composing){ return; }_vm.form_host=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form_data),expression:"form_data"}],attrs:{"type":"hidden","name":"data"},domProps:{"value":(_vm.form_data)},on:{"input":function($event){if($event.target.composing){ return; }_vm.form_data=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-block",attrs:{"type":"submit","disabled":_vm.report_data.length < 1}},[_c('i',{staticClass:"far fa-file-pdf"}),_vm._v(" บันทึกเป็น PDF\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('form',{attrs:{"action":"/static/excel/report_expend.php","method":"POST","target":"_blank"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.start_date),expression:"start_date"}],attrs:{"type":"hidden","name":"date_start"},domProps:{"value":(_vm.start_date)},on:{"input":function($event){if($event.target.composing){ return; }_vm.start_date=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.end_date),expression:"end_date"}],attrs:{"type":"hidden","name":"date_end"},domProps:{"value":(_vm.end_date)},on:{"input":function($event){if($event.target.composing){ return; }_vm.end_date=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form_host),expression:"form_host"}],attrs:{"type":"hidden","name":"host"},domProps:{"value":(_vm.form_host)},on:{"input":function($event){if($event.target.composing){ return; }_vm.form_host=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form_data),expression:"form_data"}],attrs:{"type":"hidden","name":"data"},domProps:{"value":(_vm.form_data)},on:{"input":function($event){if($event.target.composing){ return; }_vm.form_data=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-block",attrs:{"type":"submit","disabled":_vm.report_data.length < 1}},[_c('i',{staticClass:"far fa-file-excel"}),_vm._v(" บันทึกเป็น Excel\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"})]),_vm._v(" "),_c('div',{staticClass:"table-responsive-sm mt-3"},[_c('table',{staticClass:"table"},[_c('thead',[_c('tr',{staticClass:"text-left"},[_c('td',{attrs:{"colspan":"6"}},[_vm._v("จุดขาย: "+_vm._s(_vm.host.host_name))])])]),_vm._v(" "),_c('tbody',[_vm._m(0),_vm._v(" "),_vm._l((_vm.report_data),function(r,i){return _c('tr',{key:'datar' + i},[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(i + 1))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.dateFormatDMY(r.doc_date)))]),_vm._v(" "),_c('td',{staticClass:"text-left"},[_vm._v(_vm._s(r.description))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(r.amount)))])])}),_vm._v(" "),(_vm.report_data.length !== 0)?_c('tr',[_c('th',{staticClass:"text-center",attrs:{"colspan":"3"}},[_vm._v("รวมทั้งสิ้น")]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(_vm.count_expen(_vm.report_data))))])]):_vm._e()],2),_vm._v(" "),(_vm.report_data.length === 0)?_c('tbody',[_vm._m(1)]):_vm._e()])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"thead-dark"},[_c('th',{attrs:{"width":"5%"}},[_vm._v("#")]),_vm._v(" "),_c('th',{attrs:{"width":"20%"}},[_vm._v("วันที่")]),_vm._v(" "),_c('th',{attrs:{"width":"50%"}},[_vm._v("รายละเอียด")]),_vm._v(" "),_c('th',{attrs:{"width":"25%"}},[_vm._v("มูลค่า")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{attrs:{"scope":"row","colspan":"6"}},[_vm._v("ไม่มีข้อมูล")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/24.58b15fee346c20d6dda2.js